import angular from 'angular';
import { render, unmountComponentAtNode } from 'react-dom';
import { createElement } from 'react';
import { withProviders } from '../../../core/components';
import { SidebarFooter } from './sidebar-footer';
export default angular
    .module('doxy.sidebar.sidebarFooter', [])
    .component('sidebarFooterReact', {
    controller: class {
        constructor($element) {
            this.$element = $element;
        }
        $onInit() {
            render(createElement(withProviders(() => SidebarFooter({}))), this.$element[0]);
        }
        $onDestroy() {
            unmountComponentAtNode(this.$element[0]);
        }
    },
}).name;
